import { articles } from '@/mocks/articles';
import ArticleLayout from '@/pages/article/components/ArticleLayout';

export default function ArticleScarpe() {
  const article = articles.find((a) => a.slug === 'itaobuy-spreadsheet-scarpe-sneakers')!;
  return <ArticleLayout article={article} />;
}